<div class="d-flex align-items-center justify-content-between px-4 pt-4 px-md-8 pt-md-8">
  <h1 class="semi-bold">Sign-in to continue</h1>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline"
    data-id="hide"
  />
</div>

<p class="mt-2 mx-4 mx-md-8">It’s faster to checkout with your saved details</p>

<div class="d-flex flex-column mx-4 mx-md-8 mb-4 mb-md-8">
  <ds-button
    (click)="emitShowSignInModal()"
    label="Sign in with saved info"
    [fullWidth]="true"
    class="mt-8"
    data-id="sign-in"
  />

  <ds-button
    (click)="emitContinueAsGuest()"
    variant="secondary"
    label="Enter details manually"
    [fullWidth]="true"
    class="mt-4"
    data-id="continue-as-a-guest"
  />
</div>
